import React from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "types/store";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import styles from "./style.module.css";
import { Button } from "aible";
import WarningIcon from "images/warning.svg";
import { isEnabled } from "utils/featureFlags";
const LegacyModelWarning = (props) => {
    const { show, style, isNewChat } = props;
    const dispatch = useDispatch();
    const [showPopup, updateShowPopup] = useState(show ?? false);
    const isAsking = useSelector((state) => chatGPTReducer.getIsAsking(state));
    // const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const modelId = useSelector((state) => chatGPTReducer.getModelId(state));
    const secondaryModel = useSelector((state) => chatGPTReducer.getSecondaryModel(state));
    const shouldShowPopup = useSelector((state) => chatGPTReducer.getShouldShowDeprecatedModelWarning(state));
    const defaultLegacyWarningTitle = "These settings are attempting to use a deprecated model";
    const defaultLegacyWarningText = "Please select a different model or switch to the latest version by clicking the button below.";
    useEffect(() => {
        if (shouldShowPopup && !showPopup) {
            updateShowPopup(true);
        }
        else if (!shouldShowPopup && showPopup) {
            updateShowPopup(false);
        }
    }, [modelId, secondaryModel]);
    if (isEnabled("show-deprecated-models")) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null, showPopup === true && isAsking !== true && (React.createElement("div", { className: isNewChat ? styles.sqlWarningContainerNewChat : styles.sqlWarningContainer },
        React.createElement("div", { className: styles.sqlWarningWrapper, style: style },
            React.createElement("div", { className: styles.sqlWarningHeader },
                React.createElement("img", { className: styles.sqlWarningIcon, src: WarningIcon }),
                React.createElement("div", { className: styles.sqlWarningTitle }, defaultLegacyWarningTitle)),
            React.createElement("div", { className: styles.sqlWarningContent }, defaultLegacyWarningText),
            React.createElement("div", { className: styles.sqlWarningFooter },
                React.createElement(Button, { type: "primary", onClick: () => {
                        dispatch(chatGPTReducer.updateSelectedModelsFromDeprecated(modelId, secondaryModel));
                        if (!isNewChat) {
                            dispatch(chatGPTReducer.addNewChatMessage());
                        }
                        updateShowPopup(false);
                    } }, "Use an updated model"),
                React.createElement("a", { className: styles.sqlCancelButton, onClick: () => {
                        updateShowPopup(false);
                    } }, "Ignore Warning")))))));
};
export default LegacyModelWarning;
